import {createRouter, createWebHistory} from 'vue-router/auto'
import {routes} from 'vue-router/auto-routes'

const router = createRouter({
    history: createWebHistory("/"),
    routes: [
        ...routes,
        {
            path: "/",
            redirect: "/database",
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {top: 0}
    },
})
export default router
